import { render, staticRenderFns } from "./ForecastViolationValidationReportCard.vue?vue&type=template&id=a670fab4&scoped=true&"
import script from "./ForecastViolationValidationReportCard.vue?vue&type=script&lang=js&"
export * from "./ForecastViolationValidationReportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a670fab4",
  null
  
)

export default component.exports